export type TImageType = 'png' | 'jpeg' | 'jpg' | 'pdf' | 'unknown';
export function getFileTypeByFileName(name: string): TImageType {
  const lowerName = name.toLocaleLowerCase();
  if (lowerName.endsWith('.png')) {
    return 'png';
  } else if (lowerName.endsWith('.jpg')) {
    return 'jpg';
  } else if (lowerName.endsWith('.jpeg')) {
    return 'jpeg';
  } else if (lowerName.endsWith('.pdf')) {
    return 'pdf';
  } else {
    return 'unknown';
  }
}
